export const GMAT_SET_USER = "GMAT_SET_USER";
